import { Alert } from 'react-bootstrap';
import React, { Fragment, useContext, useRef, useState } from 'react';
import { TextField } from '@mui/material';
// contexts
import { UserContext } from '../../Contexts/UserContext/UserContext.js';
import TxStateContext from '../../Contexts/TxStateContext.js';
import SwapBotContext from '../../Contexts/SwapBotContext.js';
// hooks
import useLog from '../../hooks/useLog.js';
import useTxSender from '../../hooks/useTxSender.js';
// components
import { Row } from '../../components/Row';
import { Spaces } from '../../components/Spaces.js';
import { Tableau } from '../../components/Tableau.js';
import SoldeToken from '../../components/SoldeToken.js';
import SuccessTxSender from '../../components/SuccessTxSender.js';
import { TextDisplay } from '../../components/TextDisplay/TextDisplay.js';
// helpers
import {
	forceFloat, getLog, partial_obj, sort_pendings_first, timestamp_to_ms
} from '../../helpers/helpers.js';
import { default_func_jsx_fail } from '../../helpers/helpers.js';
import { sats_to_bsv } from "../../helpers/convert_bsv_tokens.js"
import RunContext from '../../Contexts/RunContext.js';



/**
 * generates values to display from raw array of user_sell_requests
 */
function generate_table_values_display(
	user_sell_requests, function_id, run, base_price, has_loaded, total_mult, tokenoriginjig_decimals
) {
	const log = getLog(function_id + "generate_table_values_display(): ")

	const table_values = []

	if (has_loaded && user_sell_requests && user_sell_requests.length > 0
		&& total_mult && tokenoriginjig_decimals) // not ideal but necessary until we do better
	{
		for (let i = 0; i < user_sell_requests.length; i++) {
			var user_request = user_sell_requests[i]
			var admin_request = user_request.tokenSellRequest_Admin

			// date

			// note: for sell_requests the oracle timestamp is only to improve timestamp precision, it is NOT a certainty that the oracle did answer it

			let timestamp_oracle_val = user_request.get_timestamp()
			let timestamp_cache_user_request = run.cache.get("time://" + user_request.location.split('_')[0])
			if (!timestamp_cache_user_request) timestamp_cache_user_request = run.cache.get("time://" + user_request.location)
			var timestamp = timestamp_oracle_val || timestamp_cache_user_request
			timestamp = timestamp_to_ms(timestamp)

			log("", user_request.location,
				"\n timestamp_oracle_val=", timestamp_oracle_val,
				"\n timestamp_cache_user_request=", timestamp_cache_user_request
			)
			var date = "inconnue"
			if (!isNaN(timestamp)) {
				date = new Date(timestamp).toLocaleString()
			}

			// nb_tokens sold
			var tokens_amount = admin_request.amount_to_send

			let token_mode = ""

			var nb_tokens = 0, EUR_to_receive = 0
			if (admin_request.refund_nb_tokens) {  // was refunded by admins => compute with historical values
				nb_tokens = admin_request.refund_nb_tokens
				if (admin_request.refund_base_price) {
					EUR_to_receive = admin_request.refund_base_price * nb_tokens  // already in EUR
				} else EUR_to_receive = nb_tokens * base_price
				token_mode = "refund_nb_tokens"
			}
			else if (admin_request.paid_satoshis) {  // was paid by admins => computer with historical values
				nb_tokens = admin_request.paid_for_nb_tokens
				EUR_to_receive = sats_to_bsv(admin_request.paid_satoshis) * admin_request.paid_bsveur
				token_mode = "paid_for_nb_tokens"
			}
			else { // pending order => compute using current mults
				// compute value to send with current mults & base_price
				// toFixed(0) does: 0.99=>"1" , 1.01=>"1", very important before parseInt !
				nb_tokens = parseInt((
					tokens_amount * total_mult / Math.pow(10, tokenoriginjig_decimals)
				).toFixed(0))
				EUR_to_receive = nb_tokens * base_price
				token_mode = "pending_order_recomputing_from_current_mults"
			}

			// status_jsx

			var status = user_request.get_status()
			var tx_url = "https://whatsonchain.com/tx/" + user_request.location.split('_')[0]
			var status_jsx = null

			if (status.includes("pending")) {
				status_jsx =
					<a href={tx_url} target="_blank" rel="noopener noreferrer" title="" style={{ color: "orange" }}>
						attente de paiement
					</a>
			}
			else if (status.includes("paid")) {
				status_jsx =
					<a href={tx_url} target="_blank" rel="noopener noreferrer" style={{ color: "springgreen" }}>
						payé
					</a>
			}
			else if (status.includes("refunded")) {
				status_jsx =
					<a href={tx_url} target="_blank" rel="noopener noreferrer" style={{ color: "springgreen" }}>
						remboursé
					</a>
			} else {
				status_jsx = status
			}

			// create data for this table row

			var data_for_table = {
				"date": date,
				"nb_tokens": parseInt(nb_tokens),
				"EUR_to_receive": parseFloat(EUR_to_receive).toFixed(2) + " €",
				"status_jsx": status_jsx || "", // null values in table create errors
				"status": status || "",
				"timestamp": timestamp,
				"token_mode": token_mode,
			}

			log("location ", user_request.location, "data_for_table=", data_for_table)

			table_values.push(data_for_table)
		}
	}

	// reorder table_values to make sure pendings are displayed first no matter the date
	sort_pendings_first(table_values)

	// format data to be ready to display
	const keep_keys = ["date", "nb_tokens", "EUR_to_receive", "status_jsx"]
	var table_values_display = []
	for (let i = 0; i < table_values.length; i++) {
		table_values_display.push(
			Object.values(partial_obj(table_values[i], keep_keys))
		)
	}

	return table_values_display
}




function _VentesStatusHistory(props) {
	const function_id = "VentesStatusHistory: "
	// const classname=function_id
	const log = useLog(function_id)

	const tokenName = "Delphe"
	const tokenName_plural = tokenName + "s"

	const runContext = useContext(RunContext)
	const run = runContext.run

	const swapbotContext = useContext(SwapBotContext)
	const user_sell_requests = swapbotContext.user_sell_requests
	const base_price = swapbotContext.base_price

	const userContext = useContext(UserContext)

	const total_mult = userContext.total_mult
	const tokenoriginjig_decimals = userContext.tokenoriginjig_decimals

	log("\n user_sell_requests =", user_sell_requests,
		"\n total_mult=", total_mult,
		"\n tokenoriginjig_decimals=", tokenoriginjig_decimals
	)

	const has_loaded = (user_sell_requests != null && total_mult && tokenoriginjig_decimals)

	let table_values_display = []
	// try&catch to avoid black screen if an error occurs
	try {
		table_values_display = generate_table_values_display(
			user_sell_requests, function_id, run, base_price, has_loaded, total_mult, tokenoriginjig_decimals
		)
	} catch (error) {
		let premess = "Error in " + function_id
		this.globalErrorContext.throwContextError(error, premess)
	}

	return (
		<Fragment>
			<h1><i className="fas fa-tasks"></i><Spaces count="3" />
				Status des ventes de {tokenName_plural}
			</h1>

			<Alert variant="light" style={{ margin: "20px 40px" }}>
				<i className="fa fa-info-circle" style={{ fontSize: "25px", marginRight: "15px" }} />
				Cliquez sur le status pour voir la transaction associée sur un explorateur blockchain.
			</Alert>

			<Tableau
				titles={["Date", tokenName_plural + " vendus", "BSV à recevoir", "Status"]}
				values={table_values_display}
				loading={!has_loaded}
				empty_mess="Aucune demande effectuée pour le moment."
			/>
			<br /><br />

		</Fragment>
	)
}
export const VentesStatusHistory = React.memo(_VentesStatusHistory)



export function Slide_EchangeTokens_Vente(props) {
	const function_id = "Slide_EchangeTokens_Vente: "
	// const classname = function_id
	const log = useLog(function_id)

	const tokenName = "Delphe"
	const tokenName_plural = tokenName + 's'

	// states
	const [sell_nb_tokens, set_sell_nb_tokens] = useState(null)

	// swapbotContext
	const swapbotContext = useContext(SwapBotContext)
	const base_price = swapbotContext.base_price
	const sell_oracle_priceUSD = swapbotContext.sell_oracle_priceUSD
	const isWrongTokenType_sell = swapbotContext.isWrongTokenType_sell

	// update delphetx_state based on txStateContext
	const txStateContext = useContext(TxStateContext)
	const tokenID = userContext.get_selected_coin_props().tokenid
	const tokenActionID = tokenID + "_sell" // or sell_delphe ?

	const ref_messageEndRef = useRef(null) // for autoscroll
	const array_bool_user_inputs = [Boolean(sell_nb_tokens && sell_nb_tokens > 0),]

	const userContext = useContext(UserContext)
	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (
		token_balance != null && base_price != null && sell_oracle_priceUSD != null
	)

	log("\n bool_context_has_loaded=", bool_context_has_loaded,
		"\n token_balance=", token_balance,
		"\n base_price=", base_price,
		"\n sell_oracle_priceUSD=", sell_oracle_priceUSD
	)

	// --- FUNCTIONS ---

	async function func_empty_fields() {
		set_sell_nb_tokens("")
	}

	const mess_default = "" //"Un récapitulatif des "+tokenName_plural+" à vendre va s'afficher ici"
	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	var token_value_EUR = sell_nb_tokens * base_price

	var EURtoearn_after_fees = 0
	// jsx_recap: we add each field one by one
	if (sell_nb_tokens && sell_nb_tokens > 0) {

		// for 0.02€ it's quite useless to display it so commenting
		// var blockchain_fees = sell_oracle_priceUSD + 0.005 // add some average fee estimation  // todo convert usd to eur ?

		var tokkenr_perc_fees = token_value_EUR * 0.01
		EURtoearn_after_fees = token_value_EUR - tokkenr_perc_fees

		jsx_recap = <Fragment>
			Vendre {sell_nb_tokens} {tokenName_plural} pour obtenir {EURtoearn_after_fees.toFixed(2)}€ de BSV
			<br /><br />
			(après déduction des frais de conversion de 1%)
			{/* + frais blockchain pour la transaction: {ceil_to_2_decimals(blockchain_fees)}€ de BSV<br/> */}
		</Fragment>
	}

	const jsx_sending = <Fragment>
		Envoi de la demande de vente de {sell_nb_tokens} {tokenName_plural} en cours...&nbsp;
		<i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>


	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Demande de vente de {txstate.nbtokens} {tokenName_plural} envoyée avec succès ! <br />
				Elle sera traitée au plus vite.
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		_dict_sell_button_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)


	// --- FUNCTIONS ---

	function handleChange_sell_nb_tokens(event) {
		// don't allow edit during sending
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		if (txStateContext.broadcast_lock) return
		func_resetMess()

		var val = event.target.value
		// beware we want to allow '0.'
		if (val !== '0.') {
			val = forceFloat(val)
			if (Number.isNaN(val)) val = ""
		}
		if (val < 0) val = -1 * val
		log("new token_balance = ", val)

		set_sell_nb_tokens(val)
	}


	function vendreTokens(event) {
		event.preventDefault()  // prevent redirection

		// don't allow edit during sending
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		swapbotContext.sellTokens(tokenActionID, sell_nb_tokens, tokenName)
	}


	// --- DISPLAY ---

	const has_error_remaining_tokens = Boolean(
		(token_balance - sell_nb_tokens < 0)
	)
	var dict_sell_button_style = _dict_sell_button_style
	if (
		has_error_remaining_tokens
		|| !bool_context_has_loaded || txStateContext.broadcast_lock
		|| !sell_nb_tokens || sell_nb_tokens <= 0
	) {
		dict_sell_button_style = {
			backgroundColor: "gray",
			pointerEvents: "none",
		}
	}


	const maxInput_isReady = Boolean(token_balance)
	function handleClick_maxInput() {
		let fake_event = { target: {} }
		fake_event.target.value = token_balance
		handleChange_sell_nb_tokens(fake_event)
	}


	if (isWrongTokenType_sell) {
		return <div>
			Ventes non disponibles pour ce type de token
		</div>
	}

	return (
		<div>
			<h1><i className="fas fa-hand-holding-usd" /><Spaces count="3" />
				Vente de {tokenName_plural}
			</h1>
			<br />

			<Alert variant="light">
				<i style={{ fontSize: "25px", marginRight: "10px" }} className="fa fa-info-circle" />
				Les ventes de delphes sont traitées manuellement au plus vite.
			</Alert>
			<br />

			<center>
				<SoldeToken />
				<br />
			</center>

			{/* <RowWithTitle title={<Fragment>
					Nombre de {tokenName_plural} à vendre
				</Fragment>}>
				<input type='text' placeholder="ex: 300" value={sell_nb_tokens}
						onChange={handleChange_sell_nb_tokens} id='update_sell_nb_tokens' className='item'/>
			</RowWithTitle>	 */}

			<Row>
				<TextField fullWidth
					id="outlined-basic" variant="outlined"
					label={<span>Nombre de {tokenName_plural} à vendre</span>}
					value={sell_nb_tokens ? sell_nb_tokens : ""}
					onChange={handleChange_sell_nb_tokens}
					placeholder="ex: 300"
					error={has_error_remaining_tokens}
					helperText={has_error_remaining_tokens ?
						"vous n'avez pas assez de " + tokenName_plural
						: null}
					InputProps={maxInput_isReady ? {
						endAdornment:
							<span style={{ cursor: "pointer", color: "lightgrey" }}
								onClick={handleClick_maxInput}>
								MAX
							</span>
					} : {}}
				/>
			</Row><br />

			<center>
				<div ref={ref_messageEndRef}>
					{/* note: seems like the ref only works if it's NOT in some conditional rendering */}
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<button className="submitbutton" onClick={vendreTokens}
					style={dict_sell_button_style}>
					Vendre {sell_nb_tokens} {tokenName_plural}
					{EURtoearn_after_fees ?
						" pour " + EURtoearn_after_fees.toFixed(2) + "€"
						: ""}
				</button>
			</Row>
			<br /><br /><br /><br />

			<VentesStatusHistory />

		</div>
	)
}
